import React from "react";
import { useTranslation } from "react-i18next";

const WritingContent = ({ showExtendedLoadingMessage }) => {
  const { t } = useTranslation();
  return (
    <p className="chat-typing">
      {t("chat_mensaje_escribiendo")}
      {!showExtendedLoadingMessage && (
        <>
          <span>.</span> <span>.</span> <span>.</span>
        </>
      )}
    </p>
  );
};

export default WritingContent;
